import {
  useV2ListGovernancesForAccountQuery,
  useV2ListProductsForAccountQuery,
} from "@generated";
import SmallSpinner from "@components/SmallSpinner/SmallSpinner";

export const nonServiceRecommendationsDisplay = (nonServiceRecommendations) => {
  const { data: governances, isLoading: governancesLoading } =
    useV2ListGovernancesForAccountQuery({});
  const { data: products, isLoading: productsLoading } =
    useV2ListProductsForAccountQuery({});

  const bannerText = () => {
    const products = nonServiceRecommendations?.filter(
      (r) => r?.["item_type"] === "Material"
    )?.length;
    const governances = nonServiceRecommendations?.filter(
      (r) => r?.["item_type"] === "Governance"
    )?.length;

    return (
      <div className="nonServiceRecommendationsBanner warning">
        <span>
          <strong>Heads up!</strong> These recommendations will require changes
          to{" "}
          {products && governances
            ? "product & governance"
            : products
            ? "product"
            : "governance"}
        </span>
      </div>
    );
  };

  const recommendationDetails = (rec) => {
    if (rec.item_type === "Governance") {
      const governance = governances?.data?.find((g) => g.id == rec.item_id);
      if (!governance?.attributes) return <></>;

      const calc = governance.attributes?.["calculation-type"];
      const isFixed = calc === "fixed_hours";
      const normalized = isFixed ? "Fixed Hours" : "Percent of Total Hours";

      return (
        <div key={rec.id}>
          <div>
            <strong>Governance</strong> ({governance.attributes.name})
          </div>
          <div>
            <span>
              Originally: {normalized},{" "}
              {isFixed
                ? governance.attributes["fixed-hours"]
                : `${Number(governance.attributes.rate) * 100}%`}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M5.31229 0.666829L12.6667 8.00016L5.31229 15.3335L4.00008 14.0251L10.0423 8.00016L4.00008 1.97527L5.31229 0.666829Z"
                fill="#1C2655"
              />
            </svg>
            <span className="warningText">
              Now: {normalized}, {rec.quantity}
              {!isFixed ? "%" : ""}
            </span>
          </div>
        </div>
      );
    } else if (rec.item_type === "Material") {
      const product = products?.data?.find((p) => p.id == rec.item_id);
      if (!product?.attributes) return <></>;
      return (
        <div key={rec.id}>
          <div>
            <strong>Product</strong> ({product.attributes.name})
          </div>
          <span>Quantity: {rec.quantity}</span>
        </div>
      );
    }
  };

  if (!nonServiceRecommendations?.length) return <></>;

  if (governancesLoading) return <SmallSpinner />;

  return (
    <div className="nonServiceRecommendationsContainer">
      {bannerText()}
      {nonServiceRecommendations?.map((rec) => {
        return (
          <div key={rec.id} className="nonServiceRecommendationCard">
            {recommendationDetails(rec)}
          </div>
        );
      })}
    </div>
  );
};
